import { confidence, CURRENT_CONFIDENCE_FLAG } from "@helpers/confidence"
import getSubscriptionStatus from "@helpers/getSubscriptionStatus"
import {
  getOnboardingVersion,
  setOnboardingContext,
  setOnboardingVersion,
} from "@helpers/localStorage"
import { getSession } from "@helpers/supabase"
import { LoaderFunctionArgs, redirect } from "react-router-dom"

export default async function onboardingLoader({
  request,
}: LoaderFunctionArgs) {
  setOnboardingContext("default")

  const signedInUsersRedirect = await redirectSignedInUsers()
  if (signedInUsersRedirect) return signedInUsersRedirect

  const onboardingVariantRedirect = await redirectToOnboardingVariant(request)
  if (onboardingVariantRedirect) return onboardingVariantRedirect

  return null
}

async function redirectSignedInUsers() {
  const { data } = await getSession()

  const userId = data?.session?.user?.id

  if (userId) {
    const subscriptionStatus = await getSubscriptionStatus(userId)

    if (subscriptionStatus === "active") {
      return redirect("/account/subscription")
    } else {
      return redirect("/checkout/plans")
    }
  }
}

async function redirectToOnboardingVariant(request: Request) {
  const url = new URL(request.url)

  const isOnboardingVariantPathname = /\/onboarding\/v\d+/.test(url.pathname)

  if (isOnboardingVariantPathname) return null

  // Once we've assigned a variant for this session, trust localStorage as the
  // source of truth. The parent loader re-runs on every page transition, and
  // sales-page-only variants (e.g. v2) stay on `/onboarding/*` — so without
  // this short-circuit a single flag-resolution timeout would silently
  // overwrite the user's variant via the `default` fallback and corrupt the
  // experiment data.
  if (getOnboardingVersion()) return null

  const flag = await confidence.getFlag(CURRENT_CONFIDENCE_FLAG, {
    variant: "baseline",
  })

  switch (flag.variant) {
    case "v1":
      setOnboardingVersion("v1")
      return redirect(`/onboarding/v1${url.search}`)
    case "v2":
      setOnboardingVersion("v2")
      return null
    case "v3":
      setOnboardingVersion("v3")
      return redirect(`/onboarding/v3${url.search}`)
    default:
      setOnboardingVersion("baseline")
      return null
  }
}
